function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".bespoken_icon_trash_can_svg__cls-1{fill:#393c51}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "bespoken_icon_trash_can_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "bespoken_icon_trash_can_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("path", {
  className: "bespoken_icon_trash_can_svg__cls-1",
  d: "M11.23 17.54a.77.77 0 00.77-.77V9.38a.77.77 0 10-1.54 0v7.38a.77.77 0 00.77.78z"
}), React.createElement("path", {
  className: "bespoken_icon_trash_can_svg__cls-1",
  d: "M14.92 2.46h-3.53V1.38A1.39 1.39 0 0010 0H6.31a1.39 1.39 0 00-1.39 1.38v1.08H1.38A1.39 1.39 0 000 3.85v1.23a1.39 1.39 0 001.23 1.37v10.93A2.62 2.62 0 003.85 20h8.62a2.62 2.62 0 002.62-2.62V6.45a1.39 1.39 0 001.23-1.38V3.85a1.39 1.39 0 00-1.4-1.39zm-1.38 14.92a1.08 1.08 0 01-1.08 1.08H3.85a1.08 1.08 0 01-1.08-1.08V6.46h10.77zM6.46 2.46V2a.46.46 0 01.46-.46h2.46a.46.46 0 01.47.46v.46zm8.31 2a.46.46 0 01-.46.46H2A.46.46 0 112 4h12.31a.46.46 0 01.46.46z"
}), React.createElement("path", {
  className: "bespoken_icon_trash_can_svg__cls-1",
  d: "M8.15 17.54a.77.77 0 00.77-.77V9.38a.77.77 0 10-1.54 0v7.38a.77.77 0 00.77.78zM5.08 17.54a.77.77 0 00.77-.77V9.38a.77.77 0 00-1.54 0v7.38a.77.77 0 00.77.78z"
})));

var SvgBespokenIconTrashCan = function SvgBespokenIconTrashCan(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 16.31 20"
  }, props), _ref, _ref2);
};

export default SvgBespokenIconTrashCan;